import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { copiar, descargar, guardarJson, leerJson } from "../usuario/util";
import Diagrama from "../Diagrama";
import { PILARES } from "./todas";
import { infoServicio } from "modAws/CatalogoAws";

const reducido = () => { try { return !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches); } catch (e) { return false; } };

// «¿Qué pasa si falta este control?»: cada control de seguridad de la arquitectura se puede quitar; un atacante (en rojo) recorre su camino y o lo
// detiene el control, o llega hasta el objetivo. Debajo, la revision por los seis pilares.
const PanelSeguridad = ({ arq, onServicio }) => {
    const [sp, setSp] = useSearchParams();
    const deUrl = () => new Set((sp.get("q") || "").split(",").filter(x => arq.controles.some(c => c.id === x)));
    const [quitados, setQuitados] = useState(deUrl);
    const [tengo, setTengo] = useState(() => new Set(leerJson("guiaAws.check", {})[arq.id] || []));
    const [aviso, setAviso] = useState("");
    const [selId, setSelId] = useState(arq.controles[0] ? arq.controles[0].id : null);
    const [pausado, setPausado] = useState(reducido());
    useEffect(() => { setQuitados(deUrl()); setSelId(arq.controles[0] ? arq.controles[0].id : null); setTengo(new Set(leerJson("guiaAws.check", {})[arq.id] || [])); }, [arq.id]);
    const marcarTengo = (id) => setTengo(t => {
        const n = new Set(t); n.has(id) ? n.delete(id) : n.add(id);
        guardarJson("guiaAws.check", { ...leerJson("guiaAws.check", {}), [arq.id]: [...n] });
        return n;
    });
    const decir = (t) => { setAviso(t); setTimeout(() => setAviso(""), 2500); };
    const enlace = () => {
        const p = new URLSearchParams(sp); p.set("e", arq.id);
        if (quitados.size) p.set("q", [...quitados].join(",")); else p.delete("q");
        return `${window.location.origin}${window.location.pathname}?${p.toString()}`;
    };
    const copiarEnlace = async () => decir((await copiar(enlace())) ? "Enlace copiado" : "No se pudo copiar: copia la dirección del navegador");
    const resumen = () => {
        const L = [`# ${arq.titulo}`, "", arq.descripcion, "", `Servicios: ${arq.usa.map(id => (infoServicio(id) || { servicio: { title: id } }).servicio.title).join(", ")}`, "", "## Pasos", ...arq.pasos.map((t, k) => `${k + 1}. ${t}`), "", "## Controles de seguridad", ""];
        arq.controles.forEach(c => L.push(`- [${tengo.has(c.id) ? "x" : " "}] **${c.titulo}** — amenaza: ${c.amenaza}. ${c.como} Si falta: ${c.impacto}`));
        if (arq.pilares) { L.push("", "## Revisión por pilares", ""); PILARES.forEach(([k, t]) => L.push(`- **${t}:** ${arq.pilares[k]}`)); }
        L.push("", "_Resumen educativo de la Guía de servicios AWS; confirma los detalles con la documentación oficial._");
        descargar(`${arq.id}.md`, L.join("\n"), "text/markdown;charset=utf-8");
    };
    useEffect(() => {
        const actual = sp.get("q") || "", nuevo = [...quitados].join(",");
        if (actual === nuevo) return;
        const p = new URLSearchParams(sp); if (nuevo) p.set("q", nuevo); else p.delete("q");
        setSp(p, { replace: true });
    }, [quitados]);
    const sel = arq.controles.find(c => c.id === selId) || arq.controles[0];
    if (!sel) return null;
    const falta = quitados.has(sel.id);
    const nodosQuitados = new Set(arq.controles.filter(c => quitados.has(c.id)).map(c => c.nodo));
    const alternar = (id) => { setSelId(id); setQuitados(q => { const n = new Set(q); n.has(id) ? n.delete(id) : n.add(id); return n; }); };
    const protegidos = arq.controles.length - quitados.size;
    return (
        <>
            <div className="card mb-3" data-guia="seguridad">
                <div className="card-header d-flex align-items-center flex-wrap gap-2">
                    <b className="me-auto"><i className="fa fa-user-shield me-2 text-danger" />¿Qué pasa si falta este control?</b>
                    <span className={`badge ${quitados.size ? "bg-danger" : "bg-success"}`}>{protegidos} de {arq.controles.length} controles activos</span>
                    <button className="btn btn-sm btn-outline-secondary no-imprimir" onClick={copiarEnlace} title="Copia un enlace a esta vista, con los controles que quitaste"><i className="fa fa-link me-1" />Copiar enlace</button>
                    <button className="btn btn-sm btn-outline-secondary no-imprimir" onClick={resumen} title="Descarga un resumen en Markdown"><i className="fa fa-file-download me-1" />Resumen</button>
                    <button className="btn btn-sm btn-outline-secondary no-imprimir" onClick={() => setPausado(p => !p)}><i className={`fa fa-${pausado ? "play" : "pause"} me-1`} />{pausado ? "Reproducir" : "Pausar"}</button>
                </div>
                <div className="card-body">
                    {aviso && <div className="alert alert-info py-1 small" role="status">{aviso}</div>}
                    <p className="small text-muted mb-2">Cada control es una defensa de esta arquitectura. Quita uno con su interruptor y mira qué camino toma un atacante: con el control lo detiene, sin él llega a su objetivo.</p>
                    <Diagrama patron="libre" nodos={arq.nodos} flujosLibres={arq.flujos} grupos={arq.grupos} color="#8C4FFF" paso={0} pausado={pausado}
                        ataque={{ ruta: sel.ruta, bloqueaEn: falta ? null : sel.nodo }} quitados={nodosQuitados} />
                    <ul className="list-group mt-3">
                        {arq.controles.map(c => {
                            const off = quitados.has(c.id);
                            return (
                                <li key={c.id} className={`list-group-item ${c.id === sel.id ? "border-primary" : ""}`}>
                                    <div className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }} onClick={() => setSelId(c.id)}>
                                        <div className="form-check form-switch m-0" onClick={(e) => e.stopPropagation()}>
                                            <input className="form-check-input" type="checkbox" role="switch" id={`ctl-${c.id}`} checked={!off} onChange={() => alternar(c.id)} aria-label={`Control activo: ${c.titulo}`} />
                                        </div>
                                        <label htmlFor={`ctl-${c.id}`} className="fw-bold me-auto m-0" onClick={(e) => e.stopPropagation()}>{c.titulo}</label>
                                        <span className={`badge ${off ? "bg-danger" : "bg-success"}`}>{off ? "Quitado" : "Activo"}</span>
                                    </div>
                                    {c.id === sel.id && (
                                        <div className="mt-2 small">
                                            <div><b>Amenaza:</b> {c.amenaza}.</div>
                                            <div><b>Cómo se defiende:</b> {c.como}</div>
                                            <div className={off ? "text-danger" : "text-muted"}><b>{off ? "Lo que ocurre ahora:" : "Si faltara:"}</b> {c.impacto}</div>
                                            <div className="mt-1">{c.previene.map(id => { const i = infoServicio(id); return i ? (
                                                <button key={id} className="btn btn-sm btn-outline-secondary py-0 me-1 no-imprimir" onClick={() => onServicio && onServicio(id)}><i className={`${i.servicio.icon} me-1`} />{i.servicio.title}</button>) : null; })}</div>
                                        </div>
                                    )}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </div>
            <div className="card mb-3" data-guia="checklist">
                <div className="card-header d-flex align-items-center flex-wrap gap-2">
                    <b className="me-auto"><i className="fa fa-clipboard-check me-2 text-success" />Mi checklist de seguridad</b>
                    <span className="badge bg-success">{tengo.size} de {arq.controles.length} ({Math.round((tengo.size / arq.controles.length) * 100)} %)</span>
                </div>
                <div className="card-body">
                    <div className="progress mb-2" style={{ height: 8 }}><div className="progress-bar bg-success" style={{ width: `${(tengo.size / arq.controles.length) * 100}%` }} /></div>
                    <div className="small text-muted mb-2">Marca los controles que ya tienes en tu propia arquitectura. Se guarda en este navegador.</div>
                    {arq.controles.map(c => (
                        <div className="form-check" key={c.id}>
                            <input className="form-check-input" type="checkbox" id={`tengo-${c.id}`} checked={tengo.has(c.id)} onChange={() => marcarTengo(c.id)} />
                            <label className="form-check-label" htmlFor={`tengo-${c.id}`}>{c.titulo}</label>
                        </div>
                    ))}
                    {tengo.size < arq.controles.length && <div className="small text-danger mt-2">Pendiente: {arq.controles.filter(c => !tengo.has(c.id)).map(c => c.amenaza.toLowerCase()).join("; ")}.</div>}
                </div>
            </div>
            {arq.pilares && (
                <div className="card mb-3">
                    <div className="card-header"><b><i className="fa fa-balance-scale me-2" />Revisión por los seis pilares (Well-Architected)</b></div>
                    <div className="card-body">
                        <div className="row g-2">
                            {PILARES.map(([k, t, ic, col]) => (
                                <div className="col-md-6" key={k}>
                                    <div className="p-2 rounded h-100" style={{ borderLeft: `4px solid ${col}`, background: `${col}12` }}>
                                        <div className="fw-bold small" style={{ color: col }}><i className={`${ic} me-1`} />{t}</div>
                                        <div className="small">{arq.pilares[k]}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="small text-muted mt-2">Resumen educativo basado en los pilares del Marco de Buena Arquitectura de AWS; no reemplaza una revisión de tu caso concreto.</div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PanelSeguridad;
